module.exports = __webpack_public_path__ + "img/section2_img6.1c6cd580.png";